import { render, staticRenderFns } from "./FormBaseSetting.vue?vue&type=template&id=04bc0028&scoped=true"
import script from "./FormBaseSetting.vue?vue&type=script&lang=js"
export * from "./FormBaseSetting.vue?vue&type=script&lang=js"
import style0 from "./FormBaseSetting.vue?vue&type=style&index=0&id=04bc0028&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc0028",
  null
  
)

export default component.exports